import React from 'react'
import PropTypes from 'prop-types'
import {
  ImgAndTextWrapper,
  InfoText,
  IntroWrapper,
  PurposeImg,
} from './component.styles'
import {
  ModalHeader,
  ModalSubHeader,
} from 'components/ModalElements/component.styles'

const ModalIntro = ({ modalData }) => {
  // TODO: make sure the var names bodyCopy and subHeader match contentful names
  const { header, image, bodyCopy = '', bodyCopy2 = '', subHeader = '' } =
    modalData || {}

  return (
    <IntroWrapper>
      <ModalHeader>{header}</ModalHeader>
      {subHeader && <ModalSubHeader>{subHeader}</ModalSubHeader>}
      {bodyCopy2 && <InfoText>{bodyCopy}</InfoText>}
      <ImgAndTextWrapper>
        <PurposeImg src={image?.file?.url} />
        <InfoText>{!bodyCopy2 ? bodyCopy : bodyCopy2}</InfoText>
      </ImgAndTextWrapper>
    </IntroWrapper>
  )
}

ModalIntro.propTypes = {
  handleContinueButtonClick: PropTypes.func,
  modalData: PropTypes.shape({
    bodyCopy: PropTypes.string,
    bodyCopy2: PropTypes.string,
    header: PropTypes.string,
    image: PropTypes.object,
    nextLabel: PropTypes.string,
    subHeader: PropTypes.string,
  }),
}

export default ModalIntro
